module.exports = __webpack_public_path__ + "img/events-1.6ec22191.jpg";